'use client';

import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Fire, List } from '@phosphor-icons/react';
import { Link } from 'next-view-transitions';
import * as React from 'react';

const navSections = [
  {
    title: 'For Creatives',
    links: [
      { href: '/jobs', label: 'Jobs' },
      { href: '/bounties', label: 'Bounties' },
      { href: '/community', label: 'Community' },
      { href: '/jobs/companies', label: 'Companies' },
      { href: '/creatives', label: 'Profiles' },
    ],
  },
  {
    title: 'For Business',
    links: [
      { href: '/access', label: 'Access' },
      { href: '/turbo', label: 'Turbo' },
      { href: '/connect', label: 'Connect' },
      { href: '/jobs/pricing', label: 'Premium Jobs' },
    ],
  },
  {
    title: 'For Everyone',
    links: [
      { href: '/blog', label: 'Blog' },
      { href: '/tools', label: 'Tools' },
      { href: '/about', label: 'About us' },
      { href: '/resources', label: 'Resources' },
    ],
  },
];

export default function MobileNav() {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            <List className="text-primary size-20" />
            <span className="sr-only">Toggle Menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="border-input">
          <nav className="flex flex-col space-y-8">
            <div className="py-8">
              <Link
                href="/"
                className="mr-6 flex place-content-center items-center space-x-2"
              >
                <Fire weight="duotone" className="text-primary" size={24} />
                <span className="s font-bold tracking-wide">CreativeFuego</span>
              </Link>
            </div>
            {navSections.map((section) => (
              <div key={section.title}>
                <span className="font-display text-primary text-lg">
                  {section.title}
                </span>
                <span className="flex flex-col space-y-2 pt-2">
                  {section.links.map((link) => (
                    <Link
                      key={link.href}
                      className="hover:underline"
                      href={link.href}
                    >
                      {link.label}
                    </Link>
                  ))}
                </span>
              </div>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
}
